import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { Domain } from '@tiendanube/common/src/enums';

function useTranslationFulfillmentOrders(keyPrefix?: string): TFunction {
  const { t } = useTranslation(Domain.FULFILLMENT_ORDERS, { keyPrefix });

  return t;
}

export default useTranslationFulfillmentOrders;
